import './Strong.css';
export var strongCSS = '_wxp4dd0-3-15-1';